import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./app/app";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import LoaderPopUp from "./components/loader/loader";

import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/store";
import { PersistGate } from "redux-persist/es/integration/react";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<LoaderPopUp />} persistor={persistor}>
      <App onContextMenu={(e) => e.preventDefault()} />
    </PersistGate>
  </Provider>,
  document.querySelector("#root")
);
